import React from 'react';

interface EditorStatusBarProps {
	status: { lines: number; lineNumber: number; column: number };
	rightText?: string;
}

export const EditorStatusBar: React.FC<EditorStatusBarProps> = ({ status, rightText }) => {
	return (
		<div className="code-status-bar">
			<span className="left-status">{'</> '}Zeilen: {status.lines}   Ln {status.lineNumber} , Col {status.column}</span>
			<span className="right-status">{rightText || 'Gespeichert'}</span>
		</div>
	);
};

export default EditorStatusBar;


